import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import React from 'react';
//import imgNotAvailable from '../../Pages/Expert/AO/imageNotAvailable.png';
import { useTranslation } from 'react-i18next';

import Img1 from '../../Assets/EmptyImage.png';
import { MAX_SIZE_UPLOADED_IMG } from '../../config';
import useUtilities from '../../hooks/useUtilities';
import { CompareTwoString } from '../utils';
function UploadImage({image1,setImage1,imageUrl,setImageUrl,check,typeTraitement}) {
    UploadImage.propTypes = {
        image1: PropTypes.any,//it could be blob,
        typeTraitement:PropTypes.any,//icon pour supprimer une image ne s'affiche pas dans gestion expert (visualiser les infos d'un expert)
        setImage1: PropTypes.func,
        imageUrl:PropTypes.any,
        setImageUrl: PropTypes.func,
        check:PropTypes.func,
    };

    const { setOpenSnackBar, setSnackBarMessage } = useUtilities();
    const { i18n } = useTranslation();
    const setImage = (e) => {
        // const titreMission='titre';
        // const part2='L’ordre de mission de la mission "${titreMission}" a été modifié. Veuillez le valider.';
        // const error=`L’ordre de mission de la mission "${titreMission}" a été modifié. Veuillez le valider.`;
        if(e.target.files[0]?.size > MAX_SIZE_UPLOADED_IMG) {
            setSnackBarMessage(i18n.t('Veuillez respecter la taille maximale du fichier (2Mo)'));
            // setSnackBarMessage(i18n.t(error, { titreMission }));
            setOpenSnackBar(true);
        }
        else {
            if(check && !CompareTwoString(image1,e.target.files[0]))
                check(false);
            setImage1(e.target.files[0]);
        }
    };
    return (
        <>
            {(image1 || imageUrl) && (
                <div>
                    <div
                        style={{boxSizing: 'border-box',
                            position: 'relative',
                            alignItems:'center',
                            width: '120px',
                            height: '120px',
                            background: '#FFFFFF',
                            borderWidth: '1px 1px 4px 1px',
                            borderStyle: 'solid',
                            borderColor: '#E7EAF9',
                            borderRadius: '20px'}}
                    >
                        {imageUrl &&
                            <img
                                alt="not found"
                                width={'120px'}
                                height={'120px'}
                                style={{borderRadius: '20px'}}
                                src={imageUrl}
                            />
                        }
                        {!imageUrl &&
                            <img
                                alt="not found"
                                width={'120px'}
                                height={'120px'}
                                style={{borderRadius: '20px'}}
                                src={URL.createObjectURL( image1)}
                            />
                        }
                        <div
                            style={{
                                //position: 'absolute',
                                position: 'absolute',
                                left: '68%',
                                right: '0%',
                                top: '70.33%',
                                bottom: '0%',
                            }}
                        >
                            {typeTraitement!='readOnly' &&
                                <IconButton
                                    aria-label="delete"
                                    color="primary"
                                    size="medium"
                                    style={{background:'#214DCE',color:'white'}}
                                    onClick={() =>{
                                        setImage1(null);
                                        if(check)
                                            check(false);
                                        setImageUrl('');}
                                    }
                                >
                                    <DeleteIcon />
                                </IconButton>
                            }
                        </div>
                    </div>
                </div>
            )}
            {(!image1 && !imageUrl) &&
        (
            <form >
                <label htmlFor="myImage">
                    <div
                        style={{boxSizing: 'border-box',
                            position: 'relative',
                            width: '120px',
                            height: '120px',
                            background: '#FFFFFF',
                            borderWidth: '1px 1px 4px 1px',
                            borderStyle: 'solid',
                            borderColor: '#E7EAF9',
                            borderRadius: '20px'}}
                    >
                        <img
                            src={Img1}
                            style={{
                                position:'absolute',
                                left: '23.17%',
                                right: '23.17%',
                                top: '23.17%',
                                bottom: '23.17%',
                            }}
                        />
                        <div
                            style={{
                                //position: 'absolute',
                                position: 'absolute',
                                left: '68%',
                                right: '0%',
                                top: '70.33%',
                                bottom: '0%',
                            }}
                        >

                            <IconButton
                                color="primary"
                                aria-label="upload picture"
                                component="label"
                                size="medium"
                                style={{
                                    background:'#214DCE',
                                    color:'white'
                                }}
                            >
                                <input
                                    hidden
                                    type="file"
                                    accept="image/jpeg, image/png, image/jpg"
                                    onChange={setImage}
                                />
                                <AddIcon />
                            </IconButton>
                        </div>
                    </div>
                </label>
                <input
                    type="File"
                    // name="fileToUpload" id="fileToUpload"
                    //  type="file"
                    name="myImage"
                    id="myImage"
                    accept="image/jpeg, image/png, image/jpg"
                    onChange={setImage}
                />

            </form>
        )
            }
        </>
    );

}

export default UploadImage;